import { render, staticRenderFns } from "./selectionInput.vue?vue&type=template&id=c1bc8f0a&scoped=true&"
import script from "./selectionInput.vue?vue&type=script&lang=js&"
export * from "./selectionInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bc8f0a",
  null
  
)

export default component.exports